export const formatOptionLabel = (
  name: string,
  { isSoldOut, extraPrice }: { isSoldOut?: boolean; extraPrice?: number },
): string => {
  if (isSoldOut) return `${name} (품절)`;
  if (extraPrice) return `${name} (+${extraPrice.toLocaleString()}원)`;

  return name;
};
